/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Serve_Last_SeenInputs */

const en_serve_last_seen = /** @type {(inputs: Serve_Last_SeenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last seen ${i?.when}`)
};

const id_serve_last_seen = /** @type {(inputs: Serve_Last_SeenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`terakhir terlihat ${i?.when}`)
};

/**
* | output |
* | --- |
* | "last seen {when}" |
*
* @param {Serve_Last_SeenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_last_seen = /** @type {((inputs: Serve_Last_SeenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Last_SeenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_last_seen(inputs)
	return en_serve_last_seen(inputs)
});